import { CreateCarResourceForm } from "../../resourcesTypes"

type FieldKey = keyof CreateCarResourceForm

export enum TabsOrder {
    GENERAL,
    ACCESS_CONTROL,
    AVAILABILITY,
    NOTIFICATIONS,
}

export const fieldTabMap: { [field in FieldKey]: TabsOrder } = {
    isActive: TabsOrder.GENERAL,
    name: TabsOrder.GENERAL,
    image: TabsOrder.GENERAL,
    description: TabsOrder.GENERAL,
    carDetails: TabsOrder.GENERAL,
    closingTimes: TabsOrder.AVAILABILITY,
    accessControl: TabsOrder.ACCESS_CONTROL,
    notifications: TabsOrder.NOTIFICATIONS,
    tags: TabsOrder.GENERAL,
    bookingTime: TabsOrder.AVAILABILITY,
    closingTimesDaily: TabsOrder.AVAILABILITY,
    isClosingTimes: TabsOrder.AVAILABILITY,
    isBookingTime: TabsOrder.AVAILABILITY,
}
